<template>
  <div class="carousel-container" :style="{ height: height }">
    <slot name="prev" v-if="showNavigation" />
    <slot name="next" v-if="showNavigation" />
    <Swiper
      ref="swiperInstance"
      :modules="modules"
      :navigation="showNavigation"
      :pagination="showPagination ? { clickable: true } : false"
      :autoplay="autoplay"
      :space-between="spaceBetween"
      :slides-per-view="slidesPerView"
      v-bind="swiperOptions"
      @swiper="onSwiperInitialized"
      class="carousel-wrapper"
    >
      <SwiperSlide v-for="(item, index) in items" :key="index">
        <slot name="slide" :slide="item" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="js">
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const props = defineProps({
  items: Array,
  slidesPerView: {
    type: Number,
    default: 1,
  },
  spaceBetween: {
    type: Number,
    default: 2,
  },
  showNavigation: {
    type: Boolean,
    default: true,
  },
  showPagination: {
    type: Boolean,
    default: false,
  },
  swiperOptions: {
    type: Object,
    default: () => ({}),
  },
  autoplay: {
    type: [Boolean, Object],
    default: false,
  },
  height: {
    type: String,
    default: 'auto'
  },
});

const modules = [Navigation, Pagination, Scrollbar, A11y, Autoplay];

const swiperInstance = ref(null);

function onSwiperInitialized(swiper) {
  swiperInstance.value = swiper;
}

</script>
<style scoped>
.carousel-container ::v-deep .swiper-button-prev,
.carousel-container ::v-deep .swiper-button-next {
  width: 24px !important;
  height: 24px !important;
  margin-top: -12px !important; 
  color: var(--color-primary5);
}
.carousel-container ::v-deep .swiper-button-prev::after,
.carousel-container ::v-deep .swiper-button-next::after {
  font-size: 20px !important;
  color: var(--color-primary5);
}
.carousel-container ::v-deep .swiper-pagination-bullet{
  color: var(--color-primary5);
  background-color: var(--color-primary5);;
}
.carousel-container {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
}
.carousel-container ::v-deep .swiper {
  width: 100% !important;
  max-width: 100% !important;
}
.carousel-container ::v-deep .swiper-slide {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}
</style>